module.exports = __webpack_public_path__ + "img/support_mob.91b23df.webp";